import React from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import '../../entrevista/components/EntrevistaViewer.css';
import { useEncoderViewer } from '../hooks/useEncoderViewer';
import {
  EncoderHero,
  EncoderMetrics,
  PatientProfileSection,
  EncoderDataSection,
  ViewerActions,
} from './viewer/EncoderViewerSections';

const EncoderViewer = ({ encoderId, pacienteId }) => {
  const {
    patientInfo,
    fields,
    isEditing,
    openGood,
    metrics,
    setOpenGood,
    setField,
    handleEdit,
    handleCancel,
    handleSave,
    handleDelete,
    handleExportPDF,
  } = useEncoderViewer({ encoderId, pacienteId });

  const onFieldChange = (fieldName) => (event) => setField(fieldName, event.target.value);

  return (
    <Box className="entrevista-viewer" sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box className="entrevista-viewer__shell" sx={{ maxWidth: 1080, width: '100%' }}>
        <Box id="pdf-content" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <EncoderHero createdAt={patientInfo.createdAt} />
          <EncoderMetrics metrics={metrics} />
          <PatientProfileSection patientInfo={patientInfo} />
          <EncoderDataSection fields={fields} isEditing={isEditing} onFieldChange={onFieldChange} />
        </Box>

        <ViewerActions
          isEditing={isEditing}
          onEdit={handleEdit}
          onSave={handleSave}
          onCancel={handleCancel}
          onExportPDF={handleExportPDF}
          onDelete={handleDelete}
        />

        <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
          <Alert severity="success" onClose={() => setOpenGood(false)}>
            ¡Registro actualizado!
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default EncoderViewer;
